export const saveAuth = (data) => {
  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(data.user));
};

export const clearAuth = () => {
  localStorage.clear();
};

export const getUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};